export default __webpack_public_path__ + "static/6-fa25d442f7d6005550091c89af70c31b.png";